import {REMOVE_REGION_LIST, SET_REGION_LIST} from "./types";

const mutations = {
    [SET_REGION_LIST]: (state, regionList) => {
        state.regionList = regionList
        window.sessionStorage.removeItem('regionList')
        window.sessionStorage.setItem('regionList', JSON.stringify(regionList))
        // console.log(state.menus)
    } ,
    [REMOVE_REGION_LIST]: (state, regionList) => {
        window.sessionStorage.removeItem('regionList')
        state.regionList = []
    }
}
export default mutations